
import { useEffect, type JSX } from "react";
import { useForm } from "react-hook-form"
import { FloatingInputBootStrap, FloatinBooleanBootstrap } from "../Common/FloatingInputBootstrap";
import { useAddDonsMutation } from "../../stores/OkOkStore";
import type { ResponseError } from "../../types/CommonReponse";
import type { DonsInsert } from "../../types/Dons";
import { useTrads } from "../../contexts/trads/useTrads";
import { CivSetter } from "../Common/CivSetter";
import type { Fond } from "../../types/Fond";
import Merci from "./Merci";
import './dons.scss';

export function  DonsInsertForm ({fond}:{fond:Fond}): JSX.Element {

    const  don:DonsInsert={
        montant: 0,
        nature: false,
        civ: "",
        raison_soc: "",
        support: "",
        recurent: false,
        email: "",
        registre: "",
        nom: "",
        prenom: "",
        adresse: "",
        zip: "",
        tel: "",
        lang: "fr",
        ville: "",
        pays: "",
        remarque: "",
        fond_id:fond.id
    };
    const [addDons,result]=useAddDonsMutation();
    const { register, handleSubmit,setError, formState: { errors } } = useForm({
        defaultValues:don,
        //shouldUseNativeValidation: true,
        mode:'onBlur',
    });
    const {translate}=useTrads();

    useEffect(()=>{
        if(result.error && 'data' in result.error) {
            const server_error:ResponseError=result.error as ResponseError;
            const errors =server_error.data.error;
            if(errors){
                for (const i in errors) {
                        // @ts-expect-error i est connu!
                        setError(i, {type:'validate',message: translate(errors[i])});  
                }
                result.reset();
            }
        }
    },[setError,result,translate]);
    
    return (
        result.isSuccess ? <Merci don={result.data}/>  :(
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        <section className="don insert fond" id="don">
            <div className="intro">{translate("soutenir")}</div>
            <form onSubmit={(event) => void handleSubmit(addDons)(event)}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-4">
                            <fieldset>
                                <legend>Montant</legend>

        

                                <FloatingInputBootStrap
                                    name="montant"
                                    label={translate('don_montant')}
                                    type="text"
                                    errors={errors}
                                    registerOutput= {register("montant", {
                                        required: translate("don_error_montant_requis"),
                                        minLength: 2
                                    })} 
                                />
                            </fieldset>
                        </div>
                        <div className="col-4">
                            <fieldset>
                                <legend>{translate('Coordonnees')}</legend>
                                <CivSetter name="civ"
                                    label={translate('don_civ')}
                                    errors={errors}
                                    registerOutput= {register("civ" )} 
                                />
                                <FloatinBooleanBootstrap
                                    name="nature"
                                    label={translate('don_nature')}
                                    type="text"
                                    errors={errors}
                                    registerOutput= {register("nature" )} 
                                    
                                />
                                <FloatingInputBootStrap
                                    name="raison_soc"
                                    label={translate('don_raison_soc')}
                                    type="text"
                                    errors={errors}
                                    registerOutput= {register("raison_soc" )} 
                                />
                                <FloatingInputBootStrap
                                    name="email"
                                    label={translate('don_email')}
                                    type="email"
                                    errors={errors}
                                    registerOutput= {register("email" )} 
                                />
                                <FloatingInputBootStrap
                                    name="registre"
                                    label={translate('don_registre')}
                                    type="texte"
                                    errors={errors}
                                    registerOutput= {register("registre" )} 
                                />
                                <FloatingInputBootStrap
                                    name="nom"
                                    label={translate('don_nom')}
                                    type="texte"
                                    errors={errors}
                                    registerOutput= {register("nom" )} 
                                />
                                <FloatingInputBootStrap
                                    name="prenom"
                                    label={translate('don_prenom')}
                                    type="texte"
                                    errors={errors}
                                    registerOutput= {register("prenom" )} 
                                />
                                <FloatingInputBootStrap
                                    name="tel"
                                    label={translate('don_tel')}
                                    type="texte"
                                    errors={errors}
                                    registerOutput= {register("tel" )} 
                                />

                                <FloatingInputBootStrap
                                    name="adresse"
                                    label={translate('don_adresse')}
                                    type="texte"
                                    errors={errors}
                                    registerOutput= {register("adresse" )} 
                                />
                                <FloatingInputBootStrap
                                    name="zip"
                                    label={translate('don_zip')}
                                    type="texte"
                                    errors={errors}
                                    registerOutput= {register("zip" )} 
                                />
                                <FloatingInputBootStrap
                                    name="ville"
                                    label={translate('don_ville')}
                                    type="texte"
                                    errors={errors}
                                    registerOutput= {register("ville" )} 
                                />

                                <FloatingInputBootStrap
                                    name="pays"
                                    label={translate('don_pays')}
                                    type="texte"
                                    errors={errors}
                                    registerOutput= {register("pays" )} 
                                />
                            </fieldset>
                        </div>
                        <div className="col-4">
                            <fieldset>
                                <legend>{translate('Communication')}</legend>
                                <FloatingInputBootStrap
                                    name="remarque"
                                    label={translate('don_remarque')}
                                    type="texte"
                                    errors={errors}
                                    registerOutput= {register("remarque" )} 
                                />
                                <button type="submit">{translate('form_submit')}</button>
                            </fieldset>
                        </div>
                    </div>


                </div>
            </form>
        </section>
        )
    )
};

export default DonsInsertForm;

